import { Interval, PlanName, getPlanStatsByPricingMark } from "./v2";

interface Column {
  id: "feature" | "Standard" | "Premium";
  label: string;
  minWidth?: number;
  align?: "center" | "left";
  format?: (value: number) => string;
}

export const pricingColumns: readonly Column[] = [
  { id: "feature", label: "", align: "left", minWidth: 200 },
  {
    id: "Standard",
    label: "Standard",
    minWidth: 170,
    align: "center",
  },
  {
    id: "Premium",
    label: "Premium",
    minWidth: 170,
    align: "center",
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

interface PlanValue {
  label?: string;
  check?: boolean;
  info?: string;
  description?: string;
}

function createPlanData(
  feature: PlanValue,
  Standard: PlanValue,
  Premium: PlanValue
) {
  return { feature, Standard, Premium };
}

function createCategory(category: string) {
  return { category: category };
}

export const pricingRows = ({ customValue }) => {
  const proPlanVariant = getPlanStatsByPricingMark(
    PlanName.pro,
    Interval.monthly,
    customValue
  );
  return [
    createCategory("Features"),
    createPlanData(
      { label: "200+ AI content writing templates" },
      { check: true },
      { check: true }
    ),
    createPlanData(
      {
        label: "AI generated articles",
      },
      {
        label: "10",
      },
      {
        label: "40",
      }
    ),
    createPlanData(
      {
        label: "30+ languages",
      },
      { check: true },
      { check: true }
    ),
    createPlanData(
      {
        label: "Team collaboration",
      },
      { check: false },
      { label: "Default 3 team members" }
    ),
    createPlanData(
      {
        label: "Newest AI models",
      },
      { check: false },
      { check: true }
    ),
    createPlanData(
      { label: "Unlimited documents" },
      { check: false },
      { check: true }
    ),
    createPlanData(
      {
        label: "Wordpress Integration",
      },
      { check: false },
      { check: true }
    ),
    createPlanData(
      {
        label: "Webflow Integration",
      },
      { check: false },
      { check: true }
    ),
    createPlanData(
      {
        label: "Shopify Integration",
      },
      { check: false },
      { check: true }
    ),
    createPlanData(
      {
        label: "Medium Integration",
      },
      { check: false },
      { check: true }
    ),
  ];
};
